<template>
  <BaseDialog
    :width="'500px'"
    :text-align="'left'"
    :footer-align="'flex-end'"
    :title="$t('adminTitles.DeletePlanTitle')"
    :text="' '"
    :confirm-button-text="$t('adminTitles.Delete')"
    :cancel-button-text="$t('buttons.cancel')"
    :confirm-loading="loading"
    :confirm-disable="isConfirmDisabled"
    @close="$emit('close')"
    @confirm="onConfirm"
  >
    <div class="delete-plan-modal">
      <div class="delete-plan-modal__options">
        <div
          class="delete-plan-modal__option"
          @click="deleteType = 'delete_with_policies_and_profiles'"
        >
          <BaseRadio
            :value="deleteType === 'delete_with_policies_and_profiles'"
            name="deleteType"
          />
          <span class="delete-plan-modal__option-label">
            {{ $t('adminTitles.DeletePlanWithPoliciesAndProfiles') }}
          </span>
        </div>

        <div
          class="delete-plan-modal__option"
          @click="deleteType = 'delete_with_policies'"
        >
          <BaseRadio
            :value="deleteType === 'delete_with_policies'"
            name="deleteType"
          />
          <span class="delete-plan-modal__option-label">
            {{ $t('adminTitles.DeletePlanWithPolicies') }}
          </span>
        </div>

        <div
          class="delete-plan-modal__option"
          @click="deleteType = 'move_policies'"
        >
          <BaseRadio
            :value="deleteType === 'move_policies'"
            name="deleteType"
          />
          <span class="delete-plan-modal__option-label">
            {{ $t('adminTitles.MovePoliciesToAnotherPlan') }}
          </span>
        </div>
      </div>

      <div v-if="deleteType === 'move_policies'" class="delete-plan-modal__dropdown">
        <p class="delete-plan-modal__dropdown-label">
          {{ $t('adminTitles.SelectPlanToMove') }}
        </p>
        <BaseDropdown
          :options="planOptions"
          :selected-options="selectedPlanId"
          :placeholder="$t('adminTitles.SelectPlan')"
          :filterable="true"
          width="100%"
          @changeOptions="onPlanChange"
        />
      </div>
    </div>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/views/RenovaDashboard/components/ui-kit/BaseDialog';
import BaseRadio from '@/views/RenovaDashboard/components/ui-kit/Inputs/BaseRadio';
import BaseDropdown from '@/views/RenovaDashboard/components/ui-kit/Dropdowns/BaseDropdown';
import { mapGetters } from 'vuex';

export default {
  name: 'ModalDeletePlan',
  components: {
    BaseDialog,
    BaseRadio,
    BaseDropdown,
  },
  props: {
    plan: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deleteType: 'delete_with_policies_and_profiles',
      selectedPlanId: [],
    };
  },
  computed: {
    ...mapGetters(['programsList']),
    planOptions() {
      return this.programsList.items
        .filter((item) => item.packageId !== (this.plan?.packageId || this.plan?.program?.packageId))
        .map((item) => ({
          id: item.packageId,
          name: item.name,
        }));
    },
    isConfirmDisabled() {
      return this.deleteType === 'move_policies' && this.selectedPlanId.length === 0;
    },
  },
  methods: {
    onPlanChange(ids) {
      this.selectedPlanId = ids;
    },
    onConfirm() {
      this.$emit('confirm', {
        deleteType: this.deleteType,
        packageIdToMove: this.deleteType === 'move_policies' ? this.selectedPlanId[0] : null,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-plan-modal {
  &__text {
    margin-bottom: 24px;
    font-size: 14px;
    line-height: 1.4;
    color: var(--solid-dark-purple);
  }

  &__options {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  }

  &__option {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;

    &-label {
      font-size: 14px;
      color: var(--solid-black-purple);
    }
  }

  &__dropdown {
    margin-top: 16px;
    margin-bottom: 24px;

    &-label {
      font-size: 12px;
      color: var(--solid-dark-purple);
      margin-bottom: 8px;
    }
  }
}
</style>
